module.exports = __webpack_public_path__ + "static/media/details-14-image-3.aa2cb0f7.jpg";